<template>
    <el-dialog
        v-model="msgDialog.show"
        width="800px"
        class="class-dialog"
        :show-header="false"
        :before-close="handleClose" :close-on-click-modal="false" :close-on-press-escape="false"
    >
<!--        <el-icon @click="handleClose" class="close" size="16px" color="#ccc"-->
<!--        >-->
<!--            <CloseBold-->
<!--            />-->
<!--        </el-icon>-->
        <div class="content_bg">
            <div class="top">填写个人信息</div>
            <div class="center" v-loading="loading">
                <div class="select">
                    <div class="name">姓名</div>
                    <div class="ipt">
                        <el-input v-model="base_info.name" placeholder="请输入姓名"></el-input>
                    </div>
                </div>
                <div class="select">
                    <div class="name">高考年份</div>
                    <div class="ipt">
                        <el-select style="width: 100%" v-model="base_info.grade" placeholder="请选择高考年份">
                            <el-option label="2024" value="2024"></el-option>
                            <el-option label="2025" value="2025"></el-option>
                            <el-option label="2026" value="2026"></el-option>
                            <el-option label="2027" value="2027"></el-option>
                            <el-option label="2028" value="2028"></el-option>
                            <el-option label="2029" value="2029"></el-option>
                            <el-option label="2030" value="2030"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="select">
                    <div class="name">省份</div>
                    <div class="ipt">
                        <el-select style="width: 100%" v-model="base_info.province_id" placeholder="请选择省份"
                                   :disabled="no_change_province"
                                   @change="province_change">
                            <el-option :label="item.name" v-for="item in provinces" :value="item.id"></el-option>
                        </el-select>
                    </div>
                </div>
                <div class="select">
                    <div class="name">详细地址</div>
                    <div class="ipt">
                        <el-select style="width:200px;" v-model="base_info.city" placeholder="请选择城市"
                                   @change="cities_change">
                            <el-option
                                v-for="(item, index) in chose_cities"
                                :key="index"
                                :label="item"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                        <el-select style="width:200px;" v-model="base_info.address" placeholder="请选择详细地址">
                            <el-option
                                v-for="(item, index) in chose_areas"
                                :key="index"
                                :label="item"
                                :value="index"
                            >
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="select">
                    <div class="name">性别</div>
                    <div class="ipt" style="margin-left:20px;">
                        <el-radio-group v-model="base_info.gender">
                            <el-radio :label="1">男</el-radio>
                            <el-radio :label="2">女</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="select">
                    <div class="name">学校</div>
                    <div class="ipt">
                        <el-input v-model="base_info.school_name" placeholder="请输入学校"></el-input>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <div class="br-button" @click="cancel_tijiao">取消</div>
                <div class="ms-button" @click="tijiao">确定</div>
            </div>
        </div>
    
    </el-dialog>
</template>

<script>
import axios from "axios";
import api from "@/api";

export default {
    props: {
        msgDialog: {
            typeof: Object,
            default: {
                show: false,
            },
        },
    },
    data() {
        return {
            value: "",
            options: "",
            all_provinces: [],
            provinces: [],
            cities: [],
            areas: [],
            gaokaomoshi: [],
            province_url_list: [],
            oss_url_list: {},
            chose_cities: {},
            chose_areas: {},
            base_info: {
                'class_id': 0,
                'grade': 2024,
                'score': 550,
                'classes': 0,
                'name': '',
                'city': '',
                'address': '',
                'province': '0',
                'province_id': '',
                'subject_one': 0,
                'subject_three': 0,
                'subject_two': 0,
                'subjects': "",
                'majors': [],
                'second': [],
            },
            no_change_province: false,
            loading: true,
        };
    },
    updated() {
        this.init()
    },
    created() {
        this.init()
        let base_info = localStorage.getItem('base_info')
        if (base_info !== null && base_info !== 'null' && base_info !== '[]' && base_info !== '' && base_info !== 'undefined') {
            this.base_info = JSON.parse(base_info)
            if (this.base_info.province_id > 0) {
                this.no_change_province = true
            }
        }
        this.get_oss_list()
    },
    methods: {
        init() {
            this.no_change_province = false
            this.base_info = {
                'class_id': 0,
                'grade': 2024,
                'score': 550,
                'classes': 0,
                'name': '',
                'city': '',
                'address': '',
                'province': '0',
                'province_id': '',
                'subject_one': 0,
                'subject_three': 0,
                'subject_two': 0,
                'subjects': "",
                'majors': [],
                'second': [],
            }
        },
        handleClose() {
            this.msgDialog.show = false;
        },
        dialogVisible() {
        },
        get_oss_list() {
            let that = this
            axios.get(
                api.oss.list + '?t=' + (Date.now() + ''), {}
            ).then(function (res) {
                that.oss_url_list = res.data
                that.get_province_url()
            }).catch(function (err) {
            });
        },
        get_province_url(data) {
            let that = this
            axios.get(
                that.oss_url_list.province_url, {}
            ).then(function (res) {
                that.province_url_list = res.data
                that.get_gaokaomoshi()
            }).catch(function (err) {
                that.get_gaokaomoshi()
            });
        },
        get_gaokaomoshi() {
            let that = this
            axios.get(
                that.oss_url_list.gaokaomoshi, {}
            ).then(function (res) {
                that.gaokaomoshi = res.data
                //console.log(that.gaokaomoshi)
                that.get_agent_province()
            }).catch(function (err) {
            });
        },
        get_agent_province(){
            let local = new URL(window.location.href)
            let that = this
            axios.get(
                'https://oss.shudaozaixian.com/cache/agent_cms_info/list/' + local.hostname + '.json?time=' + new Date().getTime(), {}
            ).then(function (res) {
                if (res.data.domain) {
                    let url = 'https://oss.shudaozaixian.com/cache/agent_open_province/' + res.data.domain + '.json?time=' + new Date().getTime()
                    axios.get(url, {}).then(function (response) {
                        if (response.data) {
                            that.get_areas(response.data || []);
                            that.init()
                        }else{
                            that.get_areas([]);
                            that.init()
                        }
                    }).catch(function (error) {
                        that.get_areas([]);
                        that.init()
                    });
                }
            }).catch(function (err) {
            });
        },
        get_areas(agent_open_province = []) {
            let that = this
            axios.get(
                this.oss_url_list.areas, {}
            ).then(function (res) {
                that.cities = res.data.cities || ''
                that.areas = res.data.areas || ''
                that.all_provinces = res.data.province
                
                if(agent_open_province.length > 0){
                    for (let i in that.all_provinces) {
                        if (agent_open_province.indexOf(parseInt(i)) > -1) {
                            that.provinces.push({name: that.all_provinces[i], id: i})
                        }
                    }
                }else{
                    for (let i in that.all_provinces) {
                        if (that.gaokaomoshi[i] !== undefined) {
                            that.provinces.push({name: that.all_provinces[i], id: i})
                        }
                    }
                }
                that.base_info.city += ''
                
                that.chose_cities = that.cities[that.base_info.province_id] || []
                that.chose_areas = that.areas[that.base_info.city] || []
                that.loading = false
            }).catch(function (err) {
            });
        },
        province_change(e) {
            //console.log(e)
            this.chose_cities = this.cities[e]
            this.base_info.city = ''
            
            //console.log(this.chose_cities)
        },
        cities_change(v) {
            //console.log(this.areas[v])
            this.chose_areas = this.areas[v]
            this.base_info.address = ''
            this.base_info.city_str = this.chose_cities[v]
            
            //console.log(this.chose_areas)
        },
        cancel_tijiao() {
            if (this.base_info.province_id < 1) {
                localStorage.clear()
                this.$router.go(0)
            } else {
                this.msgDialog.show = false
            }
        },
        tijiao() {
            let that = this
            
            if (this.base_info.name.length < 1) {
                this.$notify.error({
                    title: '错误',
                    message: '请填写姓名',
                    offset: 50,
                });
                return false
            }
            
            if (this.base_info.province_id < 1) {
                this.$notify.error({
                    title: '错误',
                    message: '请选择省份',
                    offset: 50,
                });
                return false
            }
            
            let local_url = this.province_url_list[this.base_info.province_id] || null
            if (local_url !== null) {
                axios.defaults.baseURL = local_url
            } else {
                this.$notify.error({
                    title: '错误',
                    message: '信息异常!!!',
                    offset: 50,
                });
            }
            
            axios.post(
                api.user.input, this.base_info
            ).then(function (res) {
                if (res.data.data.code === 10000) {
                    //console.log(res.data.data)
                    if (res.data.data.province_id) {
                        localStorage.setItem('bind_phone', 1)
                        if (res.data.data.province_id !== undefined) {
                            localStorage.setItem('province_id', res.data.data.province_id)
                        }
                        if (res.data.data.over_time !== undefined) {
                            localStorage.setItem('over_time', res.data.data.over_time)
                        }
                        if (res.data.data.token !== undefined) {
                            localStorage.setItem('jwt', res.data.data.token)
                        }
                        let local_url = that.province_url_list[res.data.data.province_id] || null
                        if (local_url !== null) {
                            localStorage.setItem('local_url', local_url)
                        }
                        
                        that.msgDialog.show = false;
                    }
                    
                    that.get_user_info(true)
                    that.$notify({
                        title: '成功',
                        message: '信息录入成功',
                        type: 'success',
                        offset: 50,
                    });
                } else {
                    that.$notify.error({
                        title: '错误',
                        message: res.data.data.msg,
                        offset: 50,
                    });
                }
            }).catch(function (err) {
            });
        },
        get_user_info(type = false) {
            let that = this
            axios.post(
                api.user.info, {}
            ).then(function (res) {
                localStorage.setItem('base_info', JSON.stringify(res.data.data))
                if (type) {
                    that.$emit('close_edit_user_info');
                }
            }).catch(function (err) {
            });
        }
    },
};
</script>

<style lang="scss" scoped>
.content_bg {
    width: 100%;
    height: 540px;
    color: var(--font-1);
    display: flex;
    flex-direction: column;
    align-items: center;
    background-image: url('../../../assets/personal/msg_bg.png');
    
    .top {
        width: 100%;
        text-align: center;
        font-size: 24px;
        font-weight: 700;
        margin-top: 20px;
    }
    
    .center {
        width: 600px;
        margin-top: 10px;
        margin-bottom: 40px;
    }
    
    .select {
        width: 100%;
        height: 46px;
        margin-right: 0;
        border: 1px solid #e1e0e0;
        border-radius: 6px;
        color: var(--font-3);
        margin-top: 10px;
        display: flex;
        align-items: center;
        
        .name {
            height: 32px;
            width: 120px;
            padding: 0 10px;
            line-height: 32px;
            text-align: center;
            letter-spacing: 3px;
            font-size: 14px;
            white-space: nowrap;
            border-right: 1px solid #d9d9d9;
        }
        
        .ipt {
            width: calc(100% - 200px);
        }
    }
    
    .bottom {
        display: flex;
        justify-content: center;
        
        .br-button {
            width: 98px;
            height: 34px;
            line-height: 34px;
            font-size: 18px;
            margin-right: 10px;
        }
        
        .ms-button {
            width: 180px;
            height: 36px;
            text-align: center;
            line-height: 36px;
            font-size: 18px;
        }
    }
}
</style>
